import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

const SELECTOR = '[animation-stagger], [animation-stagger-single]'

export class Stagger {
  constructor() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return
    }

    gsap.registerPlugin(ScrollTrigger)

    this.mq = window.matchMedia('(max-width: 1025px)')
    this.played = false
    this.#apply()
    this.mq.addEventListener('change', () => this.#apply())
  }

  #apply() {
    this.#clear()
    if (this.mq.matches) return

    if (this.played) {
      gsap.set(SELECTOR, { autoAlpha: 1, y: 0 })
      return
    }

    this.stagger()
    this.stagger_single()
    this.played = true
  }

  #clear() {
    const els = [...document.querySelectorAll(SELECTOR)]
    gsap.killTweensOf(els)
    ScrollTrigger.getAll().forEach((st) => {
      if (st.trigger && els.includes(st.trigger)) st.kill()
    })
    gsap.set(els, { clearProps: 'opacity,visibility,transform' })
  }

  stagger() {
    gsap.set("[animation-stagger]", { y: 60, autoAlpha: 0 })

    ScrollTrigger.batch("[animation-stagger]", {
      onEnter: elements => {
        gsap.to(elements, {
          autoAlpha: 1,
          y: 0,
          opacity: 1,
          stagger: 0.2,
          duration: 0.7
        });
      },
      once: true,
      start: "top 90%"
    })
  }

  stagger_single() {
    this._elements = document.querySelectorAll('[animation-stagger-single]')

    if (!this._elements.length) return;

    this._elements.forEach(element => {
      let delay = element.getAttribute('animation-stagger-single') || 0;

      gsap.set(element, { y: 20, autoAlpha: 0 })

      gsap.to(element, {
        autoAlpha: 1,
        y: 0,
        opacity: 1,
        stagger: 0.2,
        duration: 0.7,
        delay: delay
      });
    })
  }
}
